import {
  ADD_REVIEWS,
  ADD_REVIEW_SUMMARY,
  REMOVE_REVIEW,
  UPDATE_REVIEW_FIELDS,
  REVIEW_CHANGE_STEP,
  SET_REVIEW_VALIDATION_ERRORS,
  UPDATE_REVIEW,
  SET_ACTIVE_PAGE,
  RESET_ACTIVE_PAGE,
  SET_SORT_ORDER,
  SET_REVIEW_MODAL_VISIBILITY,
  DEFAULT_SORT_ORDER,
} from '../actions/reviews';

export const initialState = {
  reviews: [],
  addReview: {
    rating: null,
    recommended: null,
    reviewTitle: '',
    reviewText: '',
    newNickname: undefined,
    step: 'addReview',
    validationErrors: [],
  },
  activePage: 1,
  sortOrder: DEFAULT_SORT_ORDER,
  summary: {
    numberOfReviews: null,
    averageRating: null,
  },
  modalVisible: false,
};

const changeReviewHelpfulness = (review, reviewId, isHelpful) => {
  if (review.reviewId !== reviewId) {
    return review;
  }
  if (isHelpful) {
    return { ...review, helpfulVotes: review.helpfulVotes + 1, customerVote: 'HELPFUL' };
  }

  return { ...review, unhelpfulVotes: review.unhelpfulVotes + 1, customerVote: 'UNHELPFUL' };
};

export default function reviews(state = initialState, action) {
  switch (action.type) {
    case UPDATE_REVIEW_FIELDS:
      return { ...state,
        addReview: {
          ...state.addReview,
          ...action.fields,
        },
      };
    case SET_REVIEW_VALIDATION_ERRORS:
      return { ...state,
        addReview: {
          ...state.addReview,
          ...{ validationErrors: action.validationErrors },
        },
      };
    case REVIEW_CHANGE_STEP:
      return { ...state,
        addReview: {
          ...state.addReview,
          ...{ step: action.step },
        } };
    case ADD_REVIEWS:
      return { ...state, ...action.reviews };
    case UPDATE_REVIEW:
      return {
        ...state,
        reviews: state.reviews.map((review) => changeReviewHelpfulness(review, action.reviewId, action.isHelpful)),
      };
    case ADD_REVIEW_SUMMARY:
      return { ...state, summary: action.reviewSummary };
    case SET_ACTIVE_PAGE:
      return { ...state, activePage: state.activePage + action.activePageDelta };
    case RESET_ACTIVE_PAGE:
      return { ...state, activePage: 1 };
    case REMOVE_REVIEW:
      return {
        ...state,
        reviews: state.reviews.filter(review => review.reviewId !== action.reviewId),
      };
    case SET_REVIEW_MODAL_VISIBILITY:
      return {
        ...state,
        modalVisible: action.modalVisible,
      };
    case SET_SORT_ORDER:
      return {
        ...state,
        sortOrder: action.sortOrder,
      };
    default:
      return state;
  }
}
